import type {TreeStructure} from '@pb/kit-component-tree-v2';

export const DATE_RANGE_NAME = 'usage-report-date-range-select';
export const USAGE_REPORT_TASK = 'generate-usage-report';
export const USAGE_REPORT_PROGRESS_LABEL = 'Generating usage report...';
export const DATE_RANGE_OPTIONS = {
    CUSTOM: {
        value: 'custom',
        label: 'Custom',
    },
    LAST_MONTH: {
        value: 'last-month',
        label: 'Last Month',
    },
    CURRENT_LICENSE: {
        value: 'current-license',
        label: 'Current License',
    },
};

export const SELECT_NAME = 'usage-report-select';
export const SELECT_OPTIONS = {
    USERS: {
        value: 'users',
        label: 'Users',
    },
    GROUPS: {
        value: 'groups',
        label: 'Group',
    },
};

export const REPORT_OPTIONS_TREE: TreeStructure = [
    {
        id: 'companySummaryReport',
        caption: 'Company Summary Report',
    },
    {
        id: 'userSummaryReport',
        caption: 'User Summary Report',
    },
    {
        id: 'userActivityTrend',
        caption: 'User Activity Trend',
    },
    {
        id: 'projectCodeSummaryReport',
        caption: 'Project Code Summary Report',
    },
    {
        id: 'rawData',
        caption: 'Raw Data',
        children: [
            {
                id: 'chargedCount',
                caption: 'Show Charged Count',
            },
            {
                id: 'showEntities',
                caption: 'Show Entities',
            },
            {
                id: 'showComments',
                caption: 'Show Comments',
            },
            {
                id: 'showIp',
                caption: 'Include IP',
            },
        ],
    },
];

export const RAW_API_CHILDREN = ['chargedCount', 'showComments', 'showEntities', 'showIp'];
